<template>
  <div>
    <!-- New vocabulary  -->
    <div class="d-flex">
      <h4 class="my-2">新出語彙</h4>
      <v-spacer />
      <AddVocabulary @resetList="fetchVocabularyList" />
    </div>
    <div>
      <v-chip
        class="ma-2"
        v-for="vocabulary in vocabularyList"
        :key="vocabulary.Id"
      >
        <span class="ml-3" style="white-space: pre-wrap">{{
          vocabulary.name["ja"]
        }}</span>
        <UpdateVocabulary :item="vocabulary" @resetList="fetchVocabularyList" />
        <VocabularyDelete
          :id="vocabulary.Id"
          @resetList="fetchVocabularyList"
        />
      </v-chip>
    </div>
  </div>
</template>
<script>
import AddVocabulary from "./AddVocabulary";
import VocabularyDelete from "./DeleteItemVocabulary";
import UpdateVocabulary from "./UpdateVocabulary";
import { getListVocabulary } from "@/api/Vocabulary.api";
export default {
  components: {
    AddVocabulary,
    VocabularyDelete,
    UpdateVocabulary,
  },
  data() {
    return {
      vocabularyList: [],
    };
  },
  created() {
    this.fetchVocabularyList();
  },
  methods: {
    async fetchVocabularyList() {
      let params = {
        conversation: this.$route.params.skit,
      };
      await getListVocabulary(params).then(({ result }) => {
        this.vocabularyList = result;
      });
    },
  },
};
</script>
<style scoped>
::v-deep .v-chip.v-size--default {
  height: auto;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>